import { render, staticRenderFns } from "./NotificationGuide.vue?vue&type=template&id=2aa749a2&"
import script from "./NotificationGuide.vue?vue&type=script&lang=ts&"
export * from "./NotificationGuide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports